import { handleErrors } from "../util/api-utils";

/**
 * @typedef {Object} GeneratePrincipalGeaoDocumentsRequest
 * @property {string} PostDocuSignUrl - The post DocuSign URL.
 */

/**
 * Generates a document for Principal Geao.
 * 
 * @param {GeneratePrincipalGeaoDocumentsRequest} request - The request payload.
 * @param {Function} successCallback - Callback for successful response.
 * @param {Function} errorCallback - Callback for error response.
 * @returns {Promise<void>} A promise that resolves when the operation completes.
 */
export function generatePrincipalGeaoDocuments(request, successCallback, errorCallback) {
    return fetch("/api/Docusign/GeneratePrincipalGeaoDocuments", {
        method: "post",
        body: JSON.stringify(request),
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

/**
 * @typedef {Object} GenerateProducerGeaoDocumentsRequest
 * @property {string} PostDocuSignUrl - The post DocuSign URL.
 */

/**
 * Generates a document for Producer Geao.
 * 
 * @param {GenerateProducerGeaoDocumentsRequest} request - The request payload.
 * @param {Function} successCallback - Callback for successful response.
 * @param {Function} errorCallback - Callback for error response.
 * @returns {Promise<void>} A promise that resolves when the operation completes.
 */
export function generateProducerGeaoDocuments(request, successCallback, errorCallback) {
    return fetch("/api/Docusign/GenerateProducerGeaoDocuments", {
        method: "post",
        body: JSON.stringify(request),
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

/**
 * @typedef {Object} GenerateGeaoCommissionDocumentsRequest
 * @property {boolean} EnableEncryption - Whether encryption is enabled.
 * @property {string} PingUrl - The ping URL.
 * @property {number} PingFrequency - The ping frequency.
 */

/**
 * Generates a document for Geao Commission.
 * 
 * @param {GenerateGeaoCommissionDocumentsRequest} request - The request payload.
 * @param {Function} successCallback - Callback for successful response.
 * @param {Function} errorCallback - Callback for error response.
 * @returns {Promise<void>} A promise that resolves when the operation completes.
 */
export function generateGeaoCommissionDocuments(request, successCallback, errorCallback) {
    return fetch("/api/Docusign/GenerateGeaoCommissionDocuments", {
        method: "post",
        body: JSON.stringify(request),
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

/**
 * 
 * @param {generateSweepDocument} request - The request payload.
 * @param {Function} successCallback - Callback for successful response.
 * @param {Function} errorCallback - Callback for error response.
 * @returns {Promise<void>} A promise that resolves when the operation completes.
 */
export function generateSweepDocument(request, successCallback, errorCallback) {
    return fetch("/api/Docusign/GenerateSweepDocument", {
        method: "post",
        body: JSON.stringify(request),
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

/** * 
 * @param {generateHomeAddendumDocument} request - The request payload.
 * @param {Function} successCallback - Callback for successful response.
 * @param {Function} errorCallback - Callback for error response.
 * @returns {Promise<void>} A promise that resolves when the operation completes.
 */
export function generateHomeAddendumDocument(request, successCallback, errorCallback) {
    return fetch("/api/Docusign/GenerateHomeAddendumDocument", {
        method: "post",
        body: JSON.stringify(request),
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}
